import axios from 'axios'
import { buildUrl } from '@/services/path'

export function alphanumeric (num: number, res = ''): string {
  if (!num) return res
  const allowed: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const random: any = (Math.random() * (allowed.length - 1)).toFixed()

  return alphanumeric(num - 1, res + allowed[random])
}

function escapeYAML (str: string) {
  return JSON.stringify(str)
}

function buildOptionalUrl (value: string | undefined) {
  return value ? buildUrl(value) : ''
}

function setOrRemoveVariable (compose: string, variable: string, value: string): string {
  if (value === '') {
    const regex = new RegExp(`.*: *\\\${${variable}}\\n`)
    return compose.replace(regex, '')
  } else {
    const regex = new RegExp(`\\\${${variable}}`)
    return compose.replace(regex, escapeYAML(value))
  }
}

function toUnryoDockerCompose
(
  compose: string,
  unryoToken: string,
  vaultToken: string,
  uuid: string,
  deploymentName: string,
  adminPassword?: string
): string {
  const brokerUrl = buildOptionalUrl(process.env.VUE_APP_BROKER_URL)
  const vaultServer = buildOptionalUrl(process.env.VUE_APP_VAULT_SERVER)
  const superviseServer = buildOptionalUrl(process.env.VUE_APP_SUPERVISE_SERVER)

  compose = setOrRemoveVariable(compose, 'BROKER_URL', brokerUrl)
  compose = setOrRemoveVariable(compose, 'VAULT_SERVER', vaultServer)
  compose = compose.replace(/\$\{TOKEN\}/g, escapeYAML(unryoToken))
  compose = compose.replace(/\$\{VAULT_TOKEN\}/g, escapeYAML(vaultToken))
  compose = compose.replace(/\?UNRYO_DEPLOYMENT_NAME is required/g, `-${deploymentName}`)
  compose = setOrRemoveVariable(compose, 'SUPERVISE_SERVER', superviseServer)
  if (adminPassword) {
    compose = compose.replace(/\$\{ADMIN_PASSWORD\}/g, escapeYAML(adminPassword))
  }
  const suuid = uuid.replace(/[^0-9a-z]/gi, '')
  compose = compose.replace(/\$\{QUALIFIER:-\}/g, `-${suuid}`)
  return compose
}

export async function generateDockerCompose
(
  device: string,
  unryoToken: string,
  vaultToken: string,
  uuid: string,
  deploymentName: string,
  adminPassword?: string
) {
  const assetsUrl = buildUrl(process.env.VUE_APP_SCRIPTS_URL)
  const url = buildUrl(assetsUrl,`docker-compose-${device}.yml`)
  return axios.get(url)
  .then((response: any) => {
    return toUnryoDockerCompose(response.data, unryoToken, vaultToken, uuid, deploymentName, adminPassword)
  })
}
